export default "__VITE_ASSET__DbDxY9WO__"